<template>
  <v-container class="pa-0 ma-0" style="height: 100%">
    <v-container
      class="pa-0 pt-2 d-flex gap-2 shortcut-main"
      style="height: 100%"
    >
      <!--right side-->
      <v-container class="pa-0 ma-0 right-side-panel">
        <div class="d-flex flex-column mt-0 pages-toolbar">
          <div class="d-flex flex-column gap-2 fixed-actions-chips">
            <!--create new-->
            <v-chip
              class="ma-0 d-flex align-center justify-center"
              color="primary"
              outlined
              @click="openNewPageDialog"
            >
              <span style="font-size: 9pt">{{ $t("newPage") }}</span>
              <v-icon size="17" class="ms-1"> mdi-plus </v-icon>
            </v-chip>
            <!--edit-->
            <v-chip
              class="ma-0 d-flex align-center justify-center"
              color="primary"
              outlined
              @click="editStatus = !editStatus"
            >
              <span style="font-size: 9pt">{{ $t("mode-edit") }}</span>
              <v-icon size="17" class="ms-1">
                {{ editStatus ? "mdi-pencil-off-outline" : "mdi-pencil-outline" }}
              </v-icon>
            </v-chip>
          </div>
          <div
            class="flex-grow-1 hide-scroll pages-list-container"
            @wheel="onPagesListWheel"
            @pointerdown="onPagesListPointerDown"
            @pointermove="onPagesListPointerMove"
            @pointerup="onPagesListPointerUp"
            @pointercancel="onPagesListPointerUp"
            @pointerleave="onPagesListPointerUp"
          >
            <div class="pages-list-scroll-inner">
              <v-chip-group
                v-model="page"
                active-class="primary--text"
                column
                class="page-chip-group-shortcut"
              >
                <!--category-->
                <v-chip
                  v-for="(item, i) in pageItems"
                  :key="i"
                  :value="item"
                  class="ma-0 d-flex flex-column align-center"
                  @click="editStatus ? openEditPageDialog(item) : selectPage(item)"
                >
                  <span style="font-size: 9pt">{{ item.name }}</span>
                  <span
                    v-if="editStatus"
                    class="dot"
                    style="
                      position: absolute;
                      top: 4px;
                      right: 4px;
                      width: 8px;
                      height: 8px;
                      background-color: blue;
                      border-radius: 50%;
                    "
                  ></span>
                </v-chip>
              </v-chip-group>
            </div>
          </div>
        </div>
      </v-container>
      <!--left side-->
      <v-container
        class="pa-0 ma-0 shortcuts-wrapper flex-grow-1"
        :class="{ 'shortcuts-wrapper--empty': !items || !items.length }"
      >
        <div v-if="!items || !items.length" class="shortcuts-empty-hint">
          <img
            :src="require('@/assets/dashboard/no-data(3).png')"
            alt=""
            class="shortcuts-empty-img"
          />
          <span>{{ $t("no-shortcut-product") }}</span>
        </div>
        <template v-else>
          <!--products-->
          <v-tooltip bottom v-for="(item, i) in items" :key="i">
            <template v-slot:activator="{ on, attrs }">
              <v-container
                v-bind="attrs"
                v-on="on"
                class="pa-1 ma-0 product-thumbnail"
                :value="editStatus"
                @click="setItem(item)"
              >
                <div
                  class="product-image-wrapper"
                  :class="{
                    'd-none': isImgVisible,
                    'd-flex justify-center': !isImgVisible,
                  }"
                >
                  <img
                    :src="item.avatar?.link || require('@/assets/imagePlacholder.png')"
                    class="w-100 product-image"
                    alt="product-img"
                  />
                </div>
                <v-card-text
                  v-if="productDetailsConfig.show_price"
                  class="text-caption pa-0"
                  :class="{ 'text-product': !isImgVisible }"
                >
                  {{ $numberFormat(item.price) || "-" }}
                </v-card-text>
                <v-card-text
                  v-if="productDetailsConfig.show_barcode"
                  class="text-caption pa-0"
                  :class="{ 'text-product': !isImgVisible }"
                >
                  {{ item.barcode || "-" }}
                </v-card-text>
                <v-card-text
                  v-if="productDetailsConfig.show_product_code"
                  class="text-caption pa-0"
                  :class="{ 'text-product': !isImgVisible }"
                >
                  {{ item.code || "-" }}
                </v-card-text>
                <v-card-text
                  class="text-caption pa-0"
                  :class="{ 'text-product': !isImgVisible }"
                  :style="
                    isImgVisible
                      ? {
                          fontSize: '9pt !important',
                          lineHeight: '22px',
                          height: '100%',
                          overflow: 'hidden',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                        }
                      : {}
                  "
                >
                  {{
                    item.name && item.name.length > 55 && isImgVisible
                      ? item.name.substring(0, 55) + "..."
                      : item.name
                  }}
                </v-card-text>
              </v-container>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </template>
      </v-container>
    </v-container>
    <v-dialog
      v-model="newPageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="newPageDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-col cols="12">
            <v-text-field
              v-model="namePage"
              height="20"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              outlined
              clearable
              :label="$t('namePage')"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-col class="px-0" cols="6">
            <v-btn
              color="primary"
              :disabled="!namePage"
              :loading="isLoading"
              @click="pageCreate"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editPageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="editPageDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-col cols="12">
            <v-text-field
              v-model="editpageItemName"
              height="20"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              outlined
              clearable
              :label="$t('namePage')"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="px-3">
          <v-col class="px-0" cols="6">
            <v-btn color="primary" :loading="isLoading" @click="pageUpdate">
              {{ $t("edit") }}
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col class="px-0 d-flex flex-row-reverse" cols="6">
            <v-btn color="pink" :loading="isLoading" @click="removePage">
              {{ $t("remove") }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="itemDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="itemDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <v-row class="mx-0 mt-4">
            <v-col class="ma-0" cols="12" md="4">
              <offlineProductAutocomplete
                ref="refBarcode"
                v-model="product"
                title="barcode/otherFields"
                type="integrator"
                displayKey="barcode"
              />
            </v-col>
            <v-col class="ma-0" cols="12" md="4">
              <offlineProductAutocomplete
                v-model="product"
                title="productName"
                type="product"
                displayKey="name"
              />
            </v-col>
            <v-col class="ma-0" cols="12" md="4">
              <offlineProductAutocomplete
                v-model="product"
                title="productCode"
                type="productCode"
                displayKey="code"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-3 mt-4">
          <v-col class="px-0" cols="6">
            <v-btn
              v-if="!itemEditStatus"
              color="primary"
              :loading="isLoading"
              @click="itemCreate"
            >
              {{ $t("submit") }}
            </v-btn>
            <v-btn
              v-if="itemEditStatus"
              color="primary"
              :loading="isLoading"
              @click="itemUpdate"
            >
              {{ $t("update") }}
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col class="px-0 d-flex flex-row-reverse" cols="6">
            <v-btn
              v-if="itemEditStatus"
              color="pink"
              :loading="isLoading"
              @click="itemRemove"
            >
              {{ $t("remove") }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
// import Product from '@/views/dashboard/pages/product/product.vue'
export default {
  name: "ProductShortcut",
  components: {
    offlineProductAutocomplete: () => import("./offlineProductAutocomplete.vue"),
    MyIcon,
  },
  props: {
    isItemDialogOpen: Boolean,
    imgVisibility: Boolean,
    productDetailsConfig: {
      type: Object,
      default: () => ({
        show_price: false,
        show_product_code: false,
        show_barcode: false,
      }),
    },
  },
  data() {
    return {
      pageTemp: null,
      product: false,
      itemDialog: false,
      editStatus: false,
      isLoading: false,
      editPageDialog: false,
      newPageDialog: false,
      itemSelect: null,
      itemEditStatus: false,
      page: null,
      editpageItemName: null,
      editpageItem: null,
      items: [],
      namePage: null,
      pageItems: [],
      pageItemsLastNonEmpty: [],
      _pagesRetryTimer: null,
      _pagesRetryCount: 0,
      isImgVisible: false,
      columnGrid: true,
      pagesListDrag: null,
    };
  },
  computed: {
    reloadShortcut: {
      get() {
        return this.$store.state.reloadShortcut;
      },
      set(val) {
        this.$store.commit("SET_RELOADSHORTCUT", val);
      },
    },
    tableHeightInvoice: {
      get() {
        return this.$store.state.tableHeightInvoice;
      },
      set(val) {
        this.$store.commit("SET_RELOAD", val);
      },
    },
  },
  watch: {
    isItemDialogOpen(val) {
      if (val) {
        this.openItemDialog();
        this.$emit("itemDialogOpened");
      }
    },
    imgVisibility(val) {
      this.isImgVisible = val;
    },
    reloadShortcut(val) {
      if (val) {
        // this.getPages();
        this.getPagesWithRetry();
        this.$store.commit("SET_RELOADSHORTCUT", false);
      }
    },
    tableHeightInvoice(val) {},
    page(val) {
      if (val) {
        this.getShortcut();
      }
    },
  },
  activated: function () {},
  mounted() {
    this.getPages();
  },
  created() {
    // window.addEventListener('resize', this.resizeHeightBody)
  },
  destroyed() {
    // window.removeEventListener('resize', this.resizeHeightBody)
  },
  beforeDestroy() {
    // window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onPagesListWheel(e) {
      if (this.$vuetify.breakpoint.width >= 1120) return;
      const el = e.currentTarget;
      if (el.scrollWidth <= el.clientWidth) return;
      el.scrollLeft += e.deltaY + e.deltaX;
      e.preventDefault();
    },
    onPagesListPointerDown(e) {
      if (this.$vuetify.breakpoint.width >= 1120) return;
      this.pagesListDrag = {
        id: e.pointerId,
        x: e.clientX,
        left: e.currentTarget.scrollLeft,
      };
    },
    onPagesListPointerMove(e) {
      const drag = this.pagesListDrag;
      if (!drag || drag.id !== e.pointerId) return;
      e.currentTarget.scrollLeft = drag.left - (e.clientX - drag.x);
    },
    onPagesListPointerUp() {
      this.pagesListDrag = null;
    },
    clearPagesRetry() {
      if (this._pagesRetryTimer) {
        clearTimeout(this._pagesRetryTimer);
        this._pagesRetryTimer = null;
      }
      this._pagesRetryCount = 0;
    },
    openItemDialog() {
      this.product = null;
      this.itemSelect = null;
      this.itemDialog = true;
    },
    itemCreate() {
      if (this.product && this.page) {
        var app = this;
        this.isLoading = true;
        app.$axios
          .get(this.$endpoint + "productpageshortcut", {
            params: {
              addItem: "active",
              product: app.product.id,
              unit: app.product.unit_id,
              page: app.page.id,
            },
          })
          .then((res) => {
            res = res.data;
            app.pageTemp = app.page;
            app.getAllProductShortcutItemsOffline();
            app.itemDialog = false;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }
    },
    itemUpdate() {
      if (this.product && this.page) {
        var app = this;
        this.isLoading = true;
        app.$axios
          .get(this.$endpoint + "productpageshortcut", {
            params: {
              updateItem: "active",
              id: app.itemSelect.item_id,
              unit: app.product.unit_id,
              product: app.product.id,
              page: app.page.id,
            },
          })
          .then((res) => {
            res = res.data;
            app.pageTemp = app.page;
            app.getAllProductShortcutItemsOffline();
            app.itemDialog = false;
            app.itemEditStatus = false;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }
    },
    itemRemove() {
      if (this.product && this.page) {
        var app = this;
        this.isLoading = true;
        app.$axios
          .get(this.$endpoint + "productpageshortcut", {
            params: {
              deleteItem: "active",
              id: app.product.item_id,
            },
          })
          .then((res) => {
            res = res.data;
            app.pageTemp = app.page;
            app.getAllProductShortcutItemsOffline();
            app.itemDialog = false;
            app.itemEditStatus = false;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }
    },
    removeItem() {},
    selectPage(item) {},
    openNewPageDialog() {
      this.newPageDialog = true;
    },
    openEditPageDialog(item) {
      this.editpageItem = item;
      this.editpageItemName = item.name;
      this.editPageDialog = true;
    },
    pageCreate() {
      var app = this;
      app.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.namePage);
      app.$axios
        .post(this.$endpoint + "productpageshortcut", formData)
        .then((res) => {
          res = res.data;
          app.pageTemp = res.data;
          app.namePage = null;
          app.newPageDialog = false;
          app.getAllProductShortcutOffline();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
          app.snakbar = false;
        });
    },
    pageUpdate() {
      var app = this;
      app.isLoading = true;
      var data = {
        name: this.editpageItemName,
      };
      app.$axios
        .put(this.$endpoint + "productpageshortcut/" + this.editpageItem.id, data)
        .then((res) => {
          res = res.data;
          app.getAllProductShortcutOffline();
          app.pageTemp = app.editpageItem;
          app.editpageItem = null;
          app.editpageItemName = null;
          app.editPageDialog = false;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
          app.snakbar = false;
        });
    },
    removePage() {
      var app = this;
      app.$axios
        .delete(this.$endpoint + "productpageshortcut/" + this.editpageItem.id)
        .then((res) => {
          res = res.data;
          app.getAllProductShortcutOffline();
          app.editPageDialog = false;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    getItems(type) {
      var app = this;
      app.$axios
        .get(this.$endpoint + "productpageshortcut", {
          params: {
            type: type,
            page: app.page ? app.page.id : null,
          },
        })
        .then((res) => {
          res = res.data;
          if (type === "page") {
            app.pageItems = res;
          } else {
            app.items = res;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    setItem(item) {
      if (this.editStatus) {
        this.product = item;
        this.itemSelect = item;
        this.itemEditStatus = true;
        this.itemDialog = true;
      } else {
        this.$emit("append", item);
      }
    },
    getPages() {
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active") {
        var app = this;
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection
          .select({
            from: "productShortcut",
          })
          .then(function (data) {
            // Keep last non-empty pages to avoid UI empty flicker during sync.
            if (data && data.length > 0) {
              app.pageItems = data;
              app.pageItemsLastNonEmpty = data;
            } else if (
              app.pageItemsLastNonEmpty &&
              app.pageItemsLastNonEmpty.length > 0
            ) {
              app.pageItems = app.pageItemsLastNonEmpty;
            } else {
              app.pageItems = data;
            }
            if (data && data.length > 0) {
              if (app.pageTemp) {
                app.page = app.pageTemp;
              } else {
                app.page = data[0];
              }
              app.pageTemp = null;
              app.getShortcut();
            }
          });
      }
    },
    getPagesWithRetry() {
      this.clearPagesRetry();

      const attempt = () => {
        this.getPages();
        if (
          (!this.pageItems || this.pageItems.length === 0) &&
          this.pageItemsLastNonEmpty?.length
        ) {
          if (this._pagesRetryCount >= 8) return;
          this._pagesRetryCount += 1;
          this._pagesRetryTimer = setTimeout(attempt, 250);
        }
      };
      attempt();
    },
    getShortcut() {
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active" && this.page) {
        var app = this;
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection
          .select({
            from: "productShortcutItems",
            where: {
              page_id: app.page.id,
            },
          })
          .then(function (data) {
            app.items = data;
            // console.log(data?.[0], Object.keys(data?.[0] || {}));
          });
      }
    },
    // getShortcut() {
    //   var isDB = localStorage.getItem("dbCreated");
    //   if (isDB && isDB === "active" && this.page) {
    //     var app = this;
    //     var connection = new window.JsStore.Connection();
    //     connection.openDb("db_" + this.$store.state.userId);
    //     connection
    //       .select({
    //         from: "productShortcutItems",
    //         where: {
    //           page_id: app.page.id,
    //         },
    //       })
    //       .then(function (shortcutItems) {
    //         const items = shortcutItems || [];
    //         if (!items.length) {
    //           app.items = [];
    //           return;
    //         }
    //         const productIds = [
    //           ...new Set(
    //             items
    //               .map((x) => x.product_id)
    //               .filter((x) => x !== null && x !== undefined)
    //           ),
    //         ];
    //         if (!productIds.length) {
    //           app.items = items.map((x) => ({ ...x, barcode: null }));
    //           return;
    //         }
    //         return connection
    //           .select({
    //             from: "products",
    //             where: {
    //               id: { in: productIds },
    //             },
    //           })
    //           .then(function (products) {
    //             const productMap = new Map((products || []).map((p) => [p.id, p]));
    //             app.items = items.map((item) => {
    //               const p = productMap.get(item.product_id);
    //               return {
    //                 ...item,
    //                 barcode: p?.barcode || null,
    //               };
    //             });

    //             console.log("shortcut first item with barcode:", app.items[0]);
    //           });
    //       })
    //       .catch((err) => {
    //         console.log("getShortcut error:", err);
    //       });
    //   }
    // },
  },
};
</script>

<style scoped>
.ellip {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: normal;
}
.shortcuts-wrapper .product-thumbnail .product-image-wrapper {
  height: 58px;
  min-height: 58px;
  width: 100%;
  align-items: center;
}
.shortcuts-wrapper .product-thumbnail .product-image {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.shortcuts-wrapper .product-thumbnail .v-card__text {
  padding: 0 !important;
  line-height: 1.1rem;
}
.shortcuts-wrapper {
  overflow: auto;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  align-self: stretch;
  scrollbar-width: none;
  gap: 0.8rem;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-content: flex-start;
  align-content: flex-start;
  background-color: #fafafae3;
  border: 1px solid #eceef2 ;
  border-radius: 6px;
  padding: 6px 8px !important;
  box-sizing: border-box;
}
.shortcuts-wrapper--empty {
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.shortcuts-empty-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #8a8f98;
  font-size: 13px;
  text-align: center;
  padding: 16px;
}
.shortcuts-empty-img {
  width: 88px;
  height: auto;
  object-fit: contain;
  opacity: 0.9;
}
.shortcuts-wrapper .product-thumbnail {
  border: 1px solid #e4e6ea;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  cursor: pointer;
  width: 100%;
  max-width: none !important;
  min-height: 130px;
  height: 130px;
  max-height: 130px;
  overflow: hidden;
  background-color: #fff;
}
.shortcuts-wrapper .product-thumbnail.tooltip {
  max-width: 40px !important;
  border: none;
}
.right-side-panel {
  width: 30%;
  height: 100%;
  max-height: 100%;
  align-self: stretch;
  min-height: 0;
  display: flex;
  overflow: hidden;
  background-color: #fafafae3;
  border: 1px solid #eceef2 ;
  border-radius: 6px;
  padding: 6px 6px !important;
  box-sizing: border-box;
}
.shortcut-main {
  min-height: 0;
  align-items: stretch;
  box-sizing: border-box;
}
.pages-toolbar {
  height: 100%;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
}
.pages-list-container {
  min-height: 0;
}
.shortcuts-wrapper .product-thumbnail img {
  /* border: 1px solid #c0c0c04f; */
  padding: 1px;
  border-radius: 3px;
}
.text-product {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .v-slide-group__content,
::v-deep .v-slide-group__wrapper {
  flex-direction: column;
}
::v-deep .v-chip.v-size--default {
  border-radius: 4px;
  border: 1px solid #c5c8ce;
  height: 28px !important;
  min-height: 28px !important;
  padding: 0 6px !important;
  min-width: 0 !important;
  width: 100%;
}
.right-side-panel ::v-deep .v-chip .v-chip__content {
  width: 100%;
  justify-content: center;
  padding: 0;
}
.fixed-actions-chips ::v-deep .v-chip .v-chip__content {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) 16px;
  align-items: center;
  justify-content: stretch;
  width: 100%;
  column-gap: 2px;
}
.fixed-actions-chips ::v-deep .v-chip span {
  text-align: right;
  justify-self: stretch;
  min-width: 0;
}
.fixed-actions-chips ::v-deep .v-chip .v-icon {
  margin: 0 !important;
  justify-self: center;
}
.right-side-panel ::v-deep .v-chip span {
  font-size: 8pt !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.right-side-panel ::v-deep .v-chip .v-icon {
  font-size: 15px !important;
  height: 15px !important;
  width: 15px !important;
  margin-left: 2px !important;
}
.fixed-actions-chips ::v-deep .v-chip .v-icon {
  margin: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
::v-deep .v-slide-group__content {
  gap: 6px;
}
.fixed-actions-chips {
  gap: 6px !important;
  width: 100%;
}
::v-deep .theme--light.v-chip:not(.v-chip--active) {
  background: #fff !important;
}
::v-deep .v-chip.primary--text.v-chip--active {
  background-color: #0066ff !important;
  color: #fff !important;
}
.hide-scroll::-webkit-scrollbar {
  display: none;
}

@media (min-width: 600px) {
  .shortcuts-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 900px) {
  .shortcuts-wrapper {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1550px) {
  .shortcuts-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.pages-list-container {
  flex: 1 1 auto;
  /* overflow-x: auto !important; */
  overflow-y: auto !important;
  padding-top: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
@media (min-width: 1120px) {
  .shortcut-main {
    flex-direction: row !important;
    align-items: stretch;
    gap: 0.5rem !important;
  }
  .right-side-panel {
    width: 98px !important;
    flex: 0 0 98px;
    max-width: 98px;
    min-width: 98px;
    height: 100% !important;
    max-height: 100% !important;
    align-self: stretch;
  }
  .pages-toolbar {
    width: 100%;
  }
  .shortcuts-wrapper {
    flex: 1 1 0 !important;
    min-width: 0;
    height: 100% !important;
    max-height: 100% !important;
    align-self: stretch;
    /* Never less than 3 cards per row on >=1120px */
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 1500px) {
  .shortcuts-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1850px) {
  .shortcuts-wrapper {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
@media (max-width: 1120px) {
  .shortcut-main {
    flex-direction: column !important;
    margin-left: 2px;
    min-height: 0;
  }
  .right-side-panel {
    width: 100% !important;
    height: 91px !important;
    flex: 0 0 91px;
    min-width: 0;
    overflow: hidden !important;
    padding: 4px 2px !important;
  }
  .pages-toolbar {
    flex-direction: row-reverse !important;
    align-items: center;
    gap: 0.5rem;
    height: 100% !important;
    min-width: 0;
    width: 100%;
  }
  .fixed-actions-chips {
    width: 92px;
    min-width: 92px;
    max-width: 92px;
    flex: 0 0 92px;
    align-self: center;
    margin-top: 0;
  }
  .pages-list-container {
    flex: 1 1 0%;
    min-width: 0 !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    padding-top: 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
    touch-action: pan-x;
    -webkit-overflow-scrolling: touch;
  }
  .pages-list-scroll-inner {
    width: max-content;
    min-width: 100%;
  }
  .pages-list-container::-webkit-scrollbar {
    display: none;
    height: 0;
  }
  ::v-deep .page-chip-group-shortcut {
    width: max-content !important;
    max-width: none !important;
  }
  ::v-deep .page-chip-group-shortcut .v-slide-group__wrapper {
    display: block !important;
    flex-direction: row !important;
    overflow: visible !important;
    contain: none !important;
    width: max-content !important;
    max-width: none !important;
  }
  ::v-deep .page-chip-group-shortcut .v-slide-group__content {
    display: grid !important;
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 28px);
    grid-auto-columns: 92px;
    gap: 6px;
    align-items: start;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: max-content !important;
    max-width: none !important;
    transform: none !important;
  }
  ::v-deep .page-chip-group-shortcut .v-chip {
    min-width: 92px !important;
    max-width: 92px !important;
    width: 92px !important;
  }
  .shortcuts-wrapper {
    flex: 1 1 0 !important;
    min-height: 0;
    height: 100% !important;
    max-height: 100% !important;
  }
}
</style>
